// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eIL1","top":"styles_top__2V3tx","left":"styles_left__18dnv","description":"styles_description__1dxQV"};